import { AuthCredentials, AuthRepository } from '../repositories/AuthRepository';
import { LoginDto, RegisterDto, ResetPasswordDto } from '../../infrastructure/dto/AuthDto';

import { AuthDomainService } from '../services/AuthDomainService';

/**
 * Use case for authentication operations
 * Orchestrates the domain model and interfaces with repositories
 */
export class AuthUseCase {
  constructor(
    private readonly authRepository: AuthRepository,
    private readonly authDomainService: AuthDomainService
  ) {}

  /**
   * Handles user login
   */
  async login(loginDto: LoginDto): Promise<string> {
    // Optional: Validate credentials before passing to repository
    // const validationResult = this.authDomainService.validateCredentialStrength(loginDto.password);

    const credentials: AuthCredentials = {
      userName: loginDto.userName,
      dbName: loginDto.dbName,
      password: loginDto.password,
      TimezoneName: loginDto.TimezoneName,
      TimezoneOffset: loginDto.TimezoneOffset
    };

    const response = await this.authRepository.login(credentials);
    return response.token;
  }

  /**
   * Logs the user out
   */
  logout(): void {
    this.authRepository.logout();
  }

  /**
   * Registers a new user
   */
  async register(registerDto: RegisterDto): Promise<void> {
    // Validate password strength
    const validationResult = this.authDomainService.validateCredentialStrength(registerDto.password);
    if (!validationResult.isValid) {
      throw new Error(validationResult.message);
    }

    return this.authRepository.register(registerDto.email, registerDto.password, registerDto.firstName, registerDto.lastName);
  }

  /**
   * Requests a password reset
   */
  async resetPassword(resetPasswordDto: ResetPasswordDto): Promise<void> {
    return this.authRepository.resetPassword(resetPasswordDto.email);
  }

  /**
   * Verifies if a token is valid
   */
  verifyToken(token: string): boolean {
    return this.authDomainService.verifyToken(token);
  }
}
